(function($){

    var Galerias = {

        $items : null,

        init : function(){

            this.$items = $( '.image-gallery-wrapper' );
            if( !this.$items.length ) return true;

            this.$items.each(function(){
                Galerias.configure( this );
            });
           
        },

        configure : function( galeria ){

            galeria.$ = galeria.$ || $( galeria );

            var data = {
                _ : galeria,
                $ : galeria.$,
                $teaser : $( '.image-gallery-teaser', galeria.$ ),
                $modal : $( '.image-gallery-modal', galeria.$ ),
                $slider : $( '.main-slider', galeria.$ )
            };

            $( 'a', data.$teaser ).on( 'click', function(e){
                e.preventDefault();
                Galerias.modalOpen( data, this );
            });
            $( 'button[data-action="open-gallery"]', data.$teaser ).on( 'click', function(e){
                e.preventDefault();
                Galerias.modalOpen( data, false );
            });

            $( '[data-action="close-modal"]', data.$modal ).on( 'click', function(e){
                e.preventDefault();
                Galerias.modalClose( data );
            });

            data.$modal.on( 'click', function(e){
                console.info( "e.target" );
                console.log( e.target );
            });

        },

        modalOpen : function( data, trigger ){

            $('html,body').css( 'overflow', 'hidden' )
            $('#masthead').removeClass( 'toup' ).addClass( 'todown' )

            if( trigger ){

                trigger.$ = trigger.$ || $( trigger );
                
                const index = trigger.$.parents( 'li' ).first().index();

                if( data.$slider.hasClass( 'slick-initialized' ) ){
                    data.$slider.slick( 'slickGoTo', index );
                }
                else {

                }

            }

            data.$modal.addClass( 'opened' );

        },

        modalClose : function( data ){

            data.$modal.removeClass( 'opened' );
            $('html,body').css( 'overflow', '' );

        }

    };
    $(function(){ Galerias.init() });

})(jQuery);
